export default __webpack_public_path__ + "static/media/Group 772.43236a15.png";